import React, {useState} from "react";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";
import {useForm} from "react-hook-form";
import {Trans, useTranslation} from "react-i18next";
import {CustomerFactory} from "@connox/typescript-library";
import {getShopId} from "../lib/getShopId";
import {emailRegExp} from "../lib/ModalWindow/ForgotPasswordModal";
import styles from "./NewsletterRegistrationInTextBlock.module.scss";

const NewsletterRegistrationInTextBlock: React.FC = () => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation();
  const [customerEmail, setCustomerEmail] = useState("");

  const Content: React.FC = () => {
    const {
      register,
      handleSubmit,
      formState: {errors},
    } = useForm<{email: string}>({
      defaultValues: {
        email: customerEmail ?? customer.email ?? "",
      },
    });
    if (customerEmail) {
      const providerData = emailProvider(customerEmail);

      return (
        <div className={styles.successMessage}>
          <h3>{t("Bitte bestätigen Sie Ihre Anmeldung")}</h3>
          <p>
            <Trans i18nKey="CallToConfirmNewsletter" values={{customerEmail}}>
              Bitte bestätigen Sie Ihre Anmeldung über den Link in der E-Mail, die wir an
              <strong>{customerEmail}</strong> gesendet haben.
            </Trans>
          </p>
          {providerData && (
            <a href={providerData.url} className="button" target="_blank" rel="noopener noreferrer">
              {t("Zu {{provider}} wechseln", {provider: providerData.title})}
            </a>
          )}
        </div>
      );
    }

    const onSubmit = handleSubmit((data: {email: string}) => {
      void CustomerFactory.createOrUpdateCustomer(getShopId(), {email: data.email, newsletterFlag: true}).then(() => {
        setCustomerEmail(data.email);
      });
    });

    return (
      <form onSubmit={onSubmit}>
        <span className={styles.invalid}>{errors.email && errors.email.message}</span>
        <input
          type="email"
          placeholder={t("Ihre E-Mail Adresse")}
          {...register("email", {
            required: true,
            pattern: {
              value: emailRegExp,
              message: t("Invalid email address"),
            },
          })}
        />
        <button className="button" formAction="submit">
          {t("Jetzt abonnieren")}
        </button>
      </form>
    );
  };

  return (
    <div className={styles.wrapper}>
      <Trans i18nKey="CallToNewsletterAndGetCoupon">
        <h2>12 % Willkommensgutschein</h2>
        <p>
          Jetzt zum Connox Newsletter anmelden und
          <strong>12 % Willkommensgutschein</strong>
          sichern<sup>1</sup>.
        </p>
      </Trans>
      <ul className={styles.advantages}>
        <li>{t("Keine Rabattaktionen mehr verpassen")}</li>
        <li>{t("Immer die neuesten Design-Highlights")}</li>
        <li>{t("Abmeldung jederzeit möglich")}</li>
      </ul>
      <Content />
    </div>
  );
};

export default NewsletterRegistrationInTextBlock;

const emailProvider = (email: string): {title: string; url: string} | null => {
  const emailMatch = /@((gmx|web|gmail|googlemail|t-online|hotmail|freenet|aol)\.(de|com|org|net))/i.exec(email);
  if (!emailMatch) return emailMatch;

  switch (emailMatch[1]) {
    case "googlemail.com":
    case "gmail.com":
      return {title: "GMail", url: "https://mail.google.com"};
    case "gmx.de":
      return {title: "GMX", url: "https://www.gmx.net"};
    default:
      return {title: emailMatch[2].toUpperCase(), url: "https://www." + emailMatch[1]};
  }
};
